import { EAvailableBrokerFlow } from '../../repositories/newbuilding-search/entities/newbuilding_broker/NewbuildingBrokerSchema';
import { IBrokerData } from '../../types/broker';

export const getPartnerRewardsLanding = (newbuildingBroker: IBrokerData | undefined): string | null => {
  if (!newbuildingBroker) {
    return null;
  }

  const { availableBrokerFlow, isPartnerRewardsRegistered, partnerRewardsFlowUrl } = newbuildingBroker;

  if (availableBrokerFlow === EAvailableBrokerFlow.WithPartnerRewards && !isPartnerRewardsRegistered) {
    return partnerRewardsFlowUrl;
  }

  return null;
};
